module.exports = __webpack_public_path__ + "img/2.5d4fbe0d.jpg";